
    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import { mapActions, mapState } from 'vuex';
    import { UpdateWartelistePayload } from '@/store/warteliste';
    import Leistung from '@/types/Leistung';
    import Impfung from '@/types/Impfung';
    import moment from 'moment';

    @Component({
        computed: {
            ...mapState('warteliste', ['loaders']),
            ...mapState('leistungen', ['leistungen']),
            ...mapState('patient', ['impfungen']),

        },
        methods: {
            ...mapActions('warteliste', ['updateWarteliste']),
        },
    })
    export default class ZurKassaDetail extends Vue {
        @Prop() visible!: boolean;

        public leistungen!: Leistung[];
        public impfungen!: Impfung[];
        public updateWarteliste!: (payload: UpdateWartelistePayload) => void;

        public get aktiveLeistungen(): Leistung[] {
            var aktiveLeistungen = this.leistungen.filter((leistung) => leistung.aktiv === 'j');
            var notAddedToKarteiLeistungen = [];
            var nameOfAllLeistungenToday = [];
            var idOfAllLeistungenToday = [];
            var now = moment();
            now.set({hour: 0, minute: 0, second: 0, millisecond: 0});
            const today = now.format('YYYY-MM-DD HH:mm:ss');

            for (var tmp = 0; tmp < this.impfungen.length; tmp++) {
                var impfungenItem = this.impfungen[tmp];
                if ((impfungenItem.leistung_bezeichnung !== null) && (impfungenItem.impfdatum === today)) {
                    nameOfAllLeistungenToday.push(impfungenItem.leistung_bezeichnung);
                    if (impfungenItem.leistung_id_inkludiert) {
                        idOfAllLeistungenToday.push(impfungenItem.leistung_id_inkludiert.toString());
                    }
                }
            }

            for (var cnt = 0; aktiveLeistungen.length > cnt; cnt++) {
                var aktiveLeistungenItem = aktiveLeistungen[cnt].bezeichnung;
                var aktiveLeistungenItemInkl = aktiveLeistungen[cnt].leistung_id;
                if (aktiveLeistungenItem) {
                    if (nameOfAllLeistungenToday.indexOf(aktiveLeistungenItem) < 0) {
                        if ((aktiveLeistungenItemInkl === null) || (
                            (aktiveLeistungenItemInkl && idOfAllLeistungenToday.indexOf(aktiveLeistungenItemInkl.toString()) < 0))) {
                            notAddedToKarteiLeistungen.push(aktiveLeistungen[cnt]);
                        }
                    }
                }
            }

            return notAddedToKarteiLeistungen;
        }

        public selectedLeistungen: number[] = [];

        @Watch('visible')
        public onChangeVisible(visible: boolean): void {
            if (visible) {
                this.selectedLeistungen = this.aktiveLeistungen
                    .filter((leistung) => leistung.aktiv_default === 'j')
                    .map((leistung) => leistung.leistung_id as number);
            }
        }

        public isSelected(leistung: Leistung): boolean {
            return this.selectedLeistungen.includes(leistung.leistung_id as number);
        }

        public onClickLeistung(leistung: Leistung): void {
            const index = this.selectedLeistungen.indexOf(leistung.leistung_id as number);
            if (index !== -1) {
                this.selectedLeistungen.splice(index, 1);
            } else {
                this.selectedLeistungen.push(leistung.leistung_id as number);
            }
        }

        public onClickZurKassaSenden(): void {
            this.updateWarteliste({
                kassa: true,
                leistungen: this.selectedLeistungen,
            });
        }
    }
